<template>
    <v-app-bar app :elevation="2" color="#1A2035" style="color:aliceblue" height="50">
        <v-app-bar-title style="color:#2ccf42">GEC & GED</v-app-bar-title>
        <v-spacer/>
        <span>{{ user.fullname }} ({{user.entity?.name}})</span>

        <v-btn :to="{ name: 'mail_list' }" class="text-none" stacked>
            <v-badge color="error" :content="count_list">
                <v-icon>mdi mdi-email-arrow-left-outline</v-icon>
                <v-tooltip
                    activator="parent"
                    location="bottom"
                >Courriers à traiter</v-tooltip>
            </v-badge>
        </v-btn>
        
        <v-btn :to="{ name: 'mail_list_internal' }" class="text-none" stacked>
            <v-badge color="error" :content="count_internal">
                <v-icon>mdi mdi-note-plus-outline</v-icon>
                <v-tooltip
                    activator="parent"
                    location="bottom"
                >Notes Internes</v-tooltip>
            </v-badge>
        </v-btn>

        <v-btn :to="{ name: 'mail_list_exit' }" class="text-none" stacked>
            <v-badge color="error" :content="count_exit">
                <v-icon>mdi mdi-email-arrow-right-outline</v-icon>
                <v-tooltip
                    activator="parent"
                    location="bottom"
                >Courriers Sortants</v-tooltip>
            </v-badge>
        </v-btn>

        <!-- <v-btn icon>
            <v-icon color="light">mdi-gesture-tap-button</v-icon>
            <v-tooltip
                activator="parent"
                location="bottom"
            >Actions rapides</v-tooltip>
        </v-btn> -->
        <!-- <v-btn class="text-none" stacked v-if="notification">
            <v-badge :content="notification" color="yellow">
                <v-icon icon="mdi-bell-outline" size="x-large" :color="notif"></v-icon>
            </v-badge>
            <v-tooltip
                activator="parent"
                location="bottom"
            >Vous avez {{ notification }} Notifications</v-tooltip>
        </v-btn> -->
        
        <MenuPopover />
    </v-app-bar>
</template>

<script>
    import { mapState } from 'vuex'
    import { APIGec } from "@/store/api";
    import MenuPopover from "@/components/layout/MenuPopover.vue"

    export default {
        name: 'AppBar',
        components: {
            MenuPopover,
        },
        data () {
            return {
                notif: 'light',
                count_list: 0,
                count_exit: 0,
                count_internal: 0,
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
                notification: state => state.notification,
                isAuthenticated: state => state.isAuthenticated,
            }),
        }, 
        mounted() {
            this.getList_1();
            this.getList_Exit();
            this.getList_Internal();
        }, 
        methods: {
            async getList_1() {
                let criteria1 = `?user_treatment=${this.user.id}`;
                let criteria2 = `&statut=1`;
                let criteria3 = `&is_closed=0`;
                let criteria4 = `&courrier=1`;
                let criteria5 = `&is_noticed=0`;

                try {
                    let response = [];
                    response = await APIGec.get(
                    `/mailworkflows/${criteria1}${criteria2}${criteria3}${criteria4}${criteria5}`
                    );
                    let mails = response.data.results;
                    let mails_filter = mails.filter((x) => x.mail.security_level != 2);
                    // Load data
                    this.count_list = mails_filter.length;
                } catch (error) {
                    console.log(error);
                }
            },

            async getList_Exit() {
                let criteria1 = `?user_treatment=${this.user.id}`;
                let criteria2 = `&statut=1`;
                let criteria3 = `&is_closed=0`;
                let criteria4 = `&courrier=2`;

                try {
                    let response = [];
                    response = await APIGec.get(
                    `/mailworkflows/${criteria1}${criteria2}${criteria3}${criteria4}`
                    );

                    // Load data
                    this.count_exit = response.data.count;
                } catch (error) {
                    console.log(error);
                }
            },

            async getList_Internal() {
                let criteria1 = `?user_treatment=${this.user.id}`;
                let criteria2 = `&statut=1`;
                let criteria3 = `&is_closed=0`;
                let criteria4 = `&courrier=3`;

                try {
                    let response = [];
                    response = await APIGec.get(
                    `/mailworkflows/${criteria1}${criteria2}${criteria3}${criteria4}`
                    );

                    // Load data
                    this.count_internal = response.data.count;
                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>